import type { TimelineEvent } from '@/types/feed';

interface ArticleTimelineProps {
  events: TimelineEvent[];
}

export default function ArticleTimeline({ events }: ArticleTimelineProps) {
  return (
    <section className="mt-10 rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <i className="ri-git-commit-line text-accent-400" />
        话题时间线
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-foreground-600">
        按时间顺序记下每个关键节点，方便你判断事情是在哪一步开始变的。
      </p>
      <ol className="relative mt-6 space-y-6 border-l border-background-200 pl-6">
        {events.map((event, index) => (
          <li key={`${event.time}-${index}`} className="relative">
            <span className="absolute -left-[30px] top-1.5 h-3 w-3 rounded-full border-2 border-background-100 bg-accent-500" />
            <time className="font-label text-xs tabular-nums text-accent-400">{event.time}</time>
            <p className="mt-1 text-sm leading-relaxed text-foreground-700">{event.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}